<template>
	<div class="container">
		<div class="home_con_1">
			<img class="home_con_1_img" :src="bannerImage" />
		</div>

		<div class="con_2">
			<div class="con_2_content">
				<div class="con_2_left">
					<p>{{ $t('join.con_2.title') }}</p>
					<p style="font-weight: bold;">{{ $t('join.con_2.market_title') }}</p>
					<p>{{ $t('join.con_2.market_content') }}</p>
					<p style="font-weight: bold;">{{ $t('join.con_2.profit_title') }}</p>
					<p>{{ $t('join.con_2.profit_content') }}</p>
				</div>
				<img class="con_2_img" src="../assets/join/join_1.jpg" />
			</div>
		</div>

		<!-- <div class="con_3">
			<div class="con_3_title">{{ $t('join.con_3.title') }}</div>
			<div class="con_3_content">
				<img class="con_3_img" :src="joinImage" />
				<div class="con_3_right">
					<p>{{ $t('join.con_3.content') }}</p>
				</div>
			</div>
		</div> -->

		<!-- <div class="con_4">
			<div class="con_4_title">{{ $t('join.con_4.title') }}</div>
			<p class="con_4_content">{{ $t('join.con_4.content') }}</p>
		</div> -->

		<div class="con_5">
			<h1 class="con_5_title">{{ $t('join.con_5.title') }}</h1>
			<p class="con_5_sub_title">{{ $t('join.con_5.sub_title') }}</p>

			<div class="con_5_t1">
				<div class="product-card">
					<img src="../assets/join/join_4_1.jpg" alt="Product" />
					<h3>{{ $t('join.con_5.con_5_t1.1.title') }}</h3>
					<p>{{ $t('join.con_5.con_5_t1.1.content') }}</p>
				</div>
				<div class="product-card">
					<img src="../assets/join/join_4_2.jpg" alt="Product" />
					<h3>{{ $t('join.con_5.con_5_t1.2.title') }}</h3>
					<p>{{ $t('join.con_5.con_5_t1.2.content') }}</p>
				</div>
			</div>
			<div class="con_5_t2">
				<div class="product-card">
					<img src="../assets/join/join_4_3.jpg" alt="Product" />
					<h3>{{ $t('join.con_5.con_5_t2.1.title') }}</h3>
					<p>{{ $t('join.con_5.con_5_t2.1.content') }}</p>
				</div>
				<div class="product-card">
					<img src="../assets/join/join_4_4.jpg" alt="Product" />
					<h3>{{ $t('join.con_5.con_5_t2.2.title') }}</h3>
					<p>{{ $t('join.con_5.con_5_t2.2.content') }}</p>
				</div>
				<div class="product-card">
					<img src="../assets/join/join_4_5.jpg" alt="Product" />
					<h3>{{ $t('join.con_5.con_5_t2.3.title') }}</h3>
					<p>{{ $t('join.con_5.con_5_t2.3.content') }}</p>
				</div>
			</div>
		</div>

		<div class="con_6">
			<div class="con_6_title">{{ $t('join.con_6.title') }}</div>
			<p class="con_6_slogan">{{ $t('join.con_6.slogan') }}</p>
			<button class="contact-btn" @click="gotoContact()">{{ $t('join.con_6.button') }}</button>
		</div>
	</div>
</template>

<script>
import { bannerApi, baseImgUrl } from '../netTool/api';

export default {
	name: 'Home',
	components: {},
	data() {
		return {
			bannerImage: ''
		};
	},
	async mounted() {
		try {
			const navId = 4;
			const response = await bannerApi.getBanner(navId);
			if (response.success) {
				this.bannerImage = baseImgUrl + response.banner.image_url;
			}
		} catch (error) {}
	},
	methods: {
		gotoContact() {
			this.$router.push('/contactus');
		}
	},
	computed: {
        joinImage() {
            return require(`../assets/join/join2-${this.$t('theme.title')}.jpg`)
        }
    },
};
</script>

<style scoped>
.container {
	background-color: white;
}

.home_con_1_img {
	width: 100%;
	height: auto;
	background-repeat: no-repeat;
	background-position: center;
}

.con_2 {
	padding: 80px 20px;
	background: #f8f9fa;
}

.con_2_content {
	display: flex;
	gap: 40px;
	max-width: 1200px;
	margin: 0 auto;
}

.con_2_left {
	flex: 1;
}

.con_2_left p:first-child {
	font-size: 32px;
	font-weight: 600;
	color: #1a1a1a;
	margin-bottom: 30px;
	line-height: 1.4;
}

.con_2_left p:not(:first-child) {
	font-size: 16px;
	line-height: 1.8;
	color: #666;
	margin: 15px 0;
}

.con_2_img {
	width: 50%;
	border-radius: 8px;
}

.con_3 {
	margin: 0 auto;
	gap: 40px;
	padding: 80px 20px;
	background-color: #3f434d;
	text-align: center;
	align-items: center;
}

.con_3_content {
	max-width: 1200px;
	display: flex;
	gap: 40px;
	align-items: center;
	text-align: center;
	margin: 0 auto;
}

.con_3_title {
	font-size: 36px;
	font-weight: 600;
	color: #fff;
	margin-bottom: 40px;
}

.con_3_img {
	width: 50%;
	border-radius: 8px;
}

.con_3_right p {
	font-size: 16px;
	line-height: 1.8;
	color: #fff;
	max-width: 500px;
	text-align: left;
}

.con_4 {
	position: relative;
	width: 100%;
	aspect-ratio: 1920/640;
	background-image: url('../assets/join/join_3.jpg');
	text-align: center;
	background-size: cover;
	background-position: center;
}

.con_4_title {
	font-size: 32px;
	font-weight: 600;
	color: #fff;
	position: absolute;
	top: 25px;
	left: 50%;
	transform: translateX(-50%);
	width: 90%;
}

.con_4_content {
	font-size: 18px;
	color: #fff;
	max-width: 800px;
	line-height: 1.8;
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	bottom: 10%;
	width: 90%;
	margin: 0 auto;
	text-align: center;
}

.con_5 {
	padding: 80px 20px;
	text-align: center;
	max-width: 1200px;
	margin: 0 auto;
}

.con_5_title {
	font-size: 36px;
	color: #333;
	margin-bottom: 15px;
}

.con_5_sub_title {
	color: #666;
	margin-bottom: 40px;
}

.con_5_t1 {
	display: grid;
	gap: 20px;
	margin-bottom: 25px;
	grid-template-columns: repeat(2, 1fr);
}

.con_5_t2 {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 20px;
	margin-bottom: 25px;
}

.product-card {
	background: #f8f8f8;
	border-radius: 8px;
	text-align: left;
	align-items: flex-start;
	padding-bottom: 20px;
	transition: transform 0.3s ease;
}

.product-card:hover {
	transform: translateY(-5px);
}

.product-card img {
	width: 100%;
	height: 200px;
	object-fit: cover;
	border-radius: 8px;
	margin-bottom: 20px;
}

.product-card h3 {
	padding-left: 15px;
	padding-right: 15px;
	font-size: 20px;
	color: #1a1a1a;
	margin-bottom: 15px;
}

.product-card p {
	padding-left: 15px;
	padding-right: 15px;
	font-size: 14px;
	color: #666;
	line-height: 1.6;
}

.con_6 {
	padding: 80px 20px;
	background: #1a1a1a;
	color: white;
	text-align: center;
	background-image: url(../assets/join/join_5.jpg);
	background-size: cover;
	background-position: center;
	position: relative;
}

.con_6::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.7);
}

.con_6_title {
	font-size: 36px;
	font-weight: 600;
	margin-bottom: 15px;
	position: relative;
	z-index: 1;
}

.con_6_slogan {
	font-size: 20px;
	color: #ccc;
	margin-bottom: 30px;
	position: relative;
	z-index: 1;
	max-width: 800px;
	margin-left: auto;
	margin-right: auto;
}

.contact-btn {
	background: #fff;
	color: black;
	border: none;
	padding: 12px 60px;
	font-size: 18px;
	border-radius: 30px;
	cursor: pointer;
	transition: all 0.3s ease;
	position: relative;
	z-index: 1;
}

.contact-btn:hover {
	background: #e0e0e0;
	transform: translateY(-2px);
}

/* 移动端适配优化 */
@media (max-width: 1024px) {
	.con_4 {
		aspect-ratio: 16/9;
	}

	.con_4_title {
		font-size: 28px;
	}

	.con_4_content {
		font-size: 16px;
		width: 90%;
	}
}

@media (max-width: 768px) {
	.con_2,
	.con_3_content {
		flex-direction: column !important;
		padding: 40px 20px;
	}

	.con_2_content {
		gap: 20px;
		flex-wrap: wrap;
	}
	.con_3_content {
		gap: 20px;
	}

	.con_2_img,
	.con_3_img {
		width: 100%;
	}

	.con_2_left p:first-child {
		font-size: 24px;
		margin-bottom: 20px;
	}

	.con_3_title {
		font-size: 28px;
		margin-bottom: 30px;
	}

	.con_3_right p {
		max-width: 100%;
	}

	.con_4 {
		aspect-ratio: 4/3;
	}

	.con_4_title {
		font-size: 24px;
		top: 20px;
	}

	.con_4_content {
		font-size: 14px;
		bottom: 15%;
		padding: 0 15px;
	}

	.con_5 {
		padding: 40px 20px;
	}

	.con_5_title {
		font-size: 28px;
	}

	.con_5_t1,
	.con_5_t2 {
		grid-template-columns: 1fr;
		gap: 15px;
	}

	.product-card img {
		height: 180px;
	}

	.con_6 {
		padding: 60px 20px;
	}

	.con_6_title {
		font-size: 28px;
	}

	.con_6_slogan {
		font-size: 16px;
	}

	.contact-btn {
		padding: 10px 40px;
		font-size: 16px;
	}
}

@media (max-width: 480px) {
	.con_2_left p:first-child {
		font-size: 20px;
	}

	.con_3_title {
		font-size: 24px;
	}

	.con_4 {
		aspect-ratio: 1;
	}

	.con_4_title {
		font-size: 20px;
		top: 15px;
	}

	.con_5_title {
		font-size: 24px;
	}

	.product-card h3 {
		font-size: 18px;
	}

	.con_6_title {
		font-size: 24px;
	}
}
</style>
